import React from 'react';
import { api } from '@/constants';
import Link from 'next/link';
import Image from 'next/image';
import style from './style.module.scss';

const getSocial = async () => {
  return api.contacts.getSocial();
};
export const Tg = async () => {
  const response = await getSocial();

  if ('error' in response) {
    return <p>ошибка</p>;
  }

  return (
    <Link target="_blank" href={response?.data?.tgLink} className={style.icon}>
      <Image
        width={45}
        height={45}
        src={process.env.NEXT_PUBLIC_APP_UPLOAD_URL + response.data.tgIcon?.url}
        alt="logo"
      />
    </Link>
  );
};
